import { showForDev } from '../helpers/envServer';

export const ACTIVE_FEATURES = showForDev ? {
  AF_ADDITIONAL_FIELD: 'AF_ADDITIONAL_FIELD',
  AF_EXPORT: 'AF_EXPORT',
  AIR_FREIGHT_REPORT: 'AIR_FREIGHT_REPORT',
  EMEA_FPC_UI: 'EMEA_FPC_UI',
  BREAKING_50: 'BREAKING_50'
} : {
  AF_ADDITIONAL_FIELD: 'airFreight_exclude_status_lastUpdatedTS',
  AF_EXPORT: 'AF_EXPORT',
  EMEA_FPC_UI: 'EMEA-FPC-UI_API',
  BREAKING_50: 'BREAKING_50'
};

export default ACTIVE_FEATURES;
